import React, { FunctionComponent, HTMLAttributes, useContext } from 'react'
import Skeleton from 'react-loading-skeleton'
import { RequestStatus } from '../../responses/response'
import { statusContext } from '../../constants/contexts'

interface Props extends HTMLAttributes<HTMLDivElement> {
    width?: number,
    height?: number,
    circle?: boolean,
    count?: number,
}

export const LoadingSkeleton: FunctionComponent<Props> = (
    {
        width,
        height,
        circle,
        count,
        children,
        ...restProps
    }
) => {
    const status: RequestStatus = useContext(statusContext)
    return <div {...restProps}>
        {
            status !== RequestStatus.FETCHING ?
                children :
                <Skeleton width={width} height={height} circle={circle} count={count}/>
        }
    </div>
}